import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal } from 'react-bootstrap';

const infoModal = (props) => {
  const { show, close, title, children, classNames } = props;

  return (
    <Modal dialogClassName={classNames} size="lg" show={show} onHide={close}>
      {props.title ? (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      ) : null}
      {children ? <Modal.Body>{children}</Modal.Body> : null}
      <Modal.Footer>
        <Button variant="primary" onClick={close}>
          <FormattedMessage id="modal.button.ok" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default infoModal;
